export default __webpack_public_path__ + "static/media/ic_error.4d1012a6.png";